if (!customElements.get('ingredients-load')) {
  customElements.define(
    'ingredients-load',
    class IngredientsLoad extends HTMLElement {
      constructor() {
        super();

        this.cardsCount = Number.parseInt(this.dataset.cardsCount);
        this.initialCount = Number.parseInt(this.dataset.initialCount);
        this.loadCount = Number.parseInt(this.dataset.loadCount);

        this.hiddenCardsCount = this.cardsCount - this.initialCount;
        this.currentHiddenIndex = 0;

        if (this.hiddenCardsCount > 0) {
          this.loadMoreBtn = this.querySelector('.load-more-btn');
          this.hiddenCards = Array.from(this.querySelectorAll('.flip-card.hidden'));
        }
      }

      connectedCallback() {
        if (this.loadMoreBtn) {
          this.loadMoreBtn.addEventListener('click', this.handleLoadClick.bind(this));
        }
      }

      handleLoadClick(event) {
        if (this.currentHiddenIndex >= this.hiddenCardsCount) return;

        this.loadMoreBtn.setAttribute('disabled', 'disabled');

        for (let i = this.currentHiddenIndex; i < this.currentHiddenIndex + this.loadCount; i++) {
          if (i >= this.hiddenCardsCount) break;
          this.hiddenCards[i].classList.remove('hidden');
        }

        this.currentHiddenIndex += this.loadCount;

        if (this.currentHiddenIndex >= this.hiddenCardsCount) {
          this.loadMoreBtn.remove();
        } else {
          this.loadMoreBtn.removeAttribute('disabled');
        }
      }

      disconnectedCallback() {
        if (this.loadMoreBtn) {
          this.loadMoreBtn.removeEventListener('click', this.handleLoadClick.bind(this));
        }
      }
    }
  );
}
